import React from 'react'

const Chiffres = () => {
    return (
        <div className="bg-[#f7ead6] p-8 lg:p-24 grid gap-12 lg:gap-28 justify-items-center">
          <div className="">
            <p className="text-3xl lg:text-5xl text-blue-800 font-semibold">
              GIREauSOL, <span className="gabriel text-yellow-400">EN CHIFFRES</span>
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:space-x-8 gap-8 lg:gap-0">
          <div className="grid justify-items-center content-center">
  <p className="text-2xl text-gray-700">Qualité de l'eau surveillée dans </p>
  <p className=" text-lg text-gray-600 text-center">
    Plus de 1500 points de surveillance afin d'assurer la sécurité sanitaire des ressources en eau.
  </p>
  <h1 className="text-5xl lg:text-7xl text-blue-400 font-semibold">+1500</h1> 
</div>
<div className="grid justify-items-center content-center text-center">
  <p className="text-2xl text-gray-700">Nombre d'espèces observées</p>
  <p className=" text-lg text-gray-600 text-center">
    Plus de 1500 espèces ont été identifiées et observées, contribuant à la biodiversité régionale.
  </p>
  <h1 className="text-5xl lg:text-7xl text-blue-400 font-semibold">+1500</h1>
</div>
<div className="grid justify-items-center content-center">
  <p className="text-2xl text-gray-700">Événements organisés</p>
  <p className=" text-lg text-gray-600 text-center">
    Des événements réguliers sont organisés pour sensibiliser le public à la conservation et à l'environnement.
  </p>
  <h1 className="text-5xl lg:text-7xl text-blue-400 font-semibold">+1500</h1>
</div>

            
          </div>
        </div>
      );
      
}

export default Chiffres